import {kGlossaryTexts} from "../../../constants/texts";

export default function GlossaryResearchModeText({isStrictMode}) {
    // Used in GlossaryResearchModeButton to display selected
    // mode texte

    // BUILD
    return (
        <span className="mb-[1px] text-[14px]">
            {isStrictMode ? kGlossaryTexts.strictSearch : kGlossaryTexts.flexSearch}
        </span>
    );
}